export default {
	root: {
		fontSize: '15px',
	},
};
